import { http } from '@/core/http/HttpFetch';
import { Injectable } from '@/core/di/Injectable';
import { localStorageModule } from '@/core/config/ConfigurationServer';
import { PreRegister } from '@/wms/domain/preRegister/PreRegister';
import { PreRegisterRepository } from '@/wms/domain/preRegister/PreRegisterRepository';

@Injectable()
export class PreRegisterServices implements PreRegisterRepository {
  private readonly API_BASE_URI: string = localStorageModule().transactions.host.API_BASE_URI;
  private readonly API_PRE_REGISTER_SAVE: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_PRE_REGISTER_SAVE;
  private readonly API_PRE_REGISTER_FINDALL: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_PRE_REGISTER_FINDALL;
  private readonly API_PRE_REGISTER_FINDALL_BULKS: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_PRE_REGISTER_FINDALL_BULKS;
  private readonly API_PRE_REGISTER_FIND_BY_PK: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_PRE_REGISTER_FIND_BY_PK;
  private readonly API_PRE_REGISTER_UPDATE: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_PRE_REGISTER_UPDATE;

  async findAll(module: string): Promise<PreRegister[]> {
    try {
      return await http.get<PreRegister[]>(`${this.API_PRE_REGISTER_FINDALL}/${module}`);
    } catch (error) {
      throw new Error(`${error}`);
    }
  }

  async findByPk(payload: { type: string; number: number }): Promise<PreRegister> {
    try {
      return await http.get<PreRegister>(
        `${this.API_PRE_REGISTER_FIND_BY_PK}type=${payload.type}&number=${payload.number}`
      );
    } catch (error) {
      throw new Error(`${error}`);
    }
  }

  async save(payload: PreRegister): Promise<PreRegister> {
    try {
      return await http.post<PreRegister>(this.API_PRE_REGISTER_SAVE, JSON.stringify(payload));
    } catch (error) {
      throw new Error(`${error}`);
    }
  }
  async update(payload: PreRegister): Promise<any> {
    try {
      return await http.post<PreRegister>(this.API_PRE_REGISTER_UPDATE, JSON.stringify(payload));
    } catch (error) {
      throw new Error(`${error}`);
    }
  }

  async findAllWithBulks(module: string): Promise<PreRegister[]> {
    try {
      return await http.get<PreRegister[]>(`${this.API_PRE_REGISTER_FINDALL_BULKS}/${module}`);
    } catch (error) {
      throw new Error(`${error}`);
    }
  }
}
